import Vue from "vue";
import ViewUI from "view-design";
import VueRouter from "vue-router";
import { canTurnTo, getToken, setToken, title } from "@/library/utils";
import store from "@/store";
import config from "@/config";
const { homeName } = config;
import Home from "@/views/Main.vue";

Vue.use(ViewUI);
Vue.use(VueRouter);

const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch((error) => error);
};

const routerList = [];
importAll(require.context("./module/", true, /\.router\.js/));

function importAll(r) {
    r.keys().forEach((key) => {
        routerList.push(r(key).default);
    });
}

export const routers = [
    {
        path: "/callback",
        name: "callback",
        meta: {
            title: "回调地址",
            hideInMenu: true,
        },
        component: () => import("@/views/callback.vue"),
    },
    {
        path: "/login",
        name: "login",
        meta: {
            title: "登录",
            hideInMenu: true,
        },
        component: () => import("@/views/Login.vue"),
    },
    {
        path: "/",
        name: "_home",
        redirect: "/home",
        component: Home,
        meta: {
            icon: "md-speedometer",
            title: "工作台",
        },
        children: [
            {
                path: "/home",
                name: "main_index",
                meta: {
                    // hideInMenu: true,
                    title: "首页",
                    notCache: true,
                    icon: "md-speedometer",
                },
                component: () => import("@/views/home/index"),
            },
        ],
    },
    {
        path: "/docs/detail/:sid",
        name: "docs-detail",
        meta: {
            title: "登录",
            hideInMenu: true,
        },
        component: () => import("@/views/wiki/detail.vue"),
    },
    {
        path: "/docs/view/:sid",
        name: "docs-view",
        meta: {
            hideInMenu: true,
            icon: "ios-folder",
            title: "知识库",
        },
        component: () => import("@/views/wiki/view.vue"),
    },
    ...routerList,
    {
        path: "/403",
        meta: {
            title: "403-权限不足",
            hideInMenu: true,
        },
        name: "error-403",
        component: () => import("@/views/error/403.vue"),
    },
    {
        path: "/*",
        name: "error-404",
        meta: {
            title: "404-页面不存在",
            hideInMenu: true,
        },
        component: () => import("@/views/error/404.vue"),
    },
    {
        path: "/500",
        meta: {
            title: "500-服务端错误",
            hideInMenu: true,
        },
        name: "error-500",
        component: () => import("@/views/error/500.vue"),
    },
];

const router = new VueRouter({
    mode: "history",
    routes: routers,
});

const LOGIN_PAGE_NAME = "login";

const turnTo = (to, access, next) => {
    if (access.isadmin) next();
    if (canTurnTo(to.name, access, routers)) next();
    // 有权限，可访问
    else next({ replace: true, name: "error-404" }); // 无权限，重定向到401页面
};

router.beforeEach((to, from, next) => {
    ViewUI.LoadingBar.start();
    const token = getToken();

    if (!token && to.name !== "callback") {
        next()
        // window.location.href = "https://inte.sumibuy.com/sso?redirect=" + to.name + "&auth_redirect=https://v4.sumibuy.com/callback"
            // window.location.href = "http://192.168.40.44:10018/sso?redirect=" + to.name + "&auth_redirect=http://192.168.10.32:9999/callback"
    } else if (token && to.name === LOGIN_PAGE_NAME) {
        next({
            name: homeName
        })
    } else {
        if (token && !store.state.user.hasGetInfo) {
            store.dispatch('getUserInfo').then(user => {
                // 拉取用户信息，通过用户权限和跳转的页面的name来判断是否有权限访问;access必须是一个数组，如：['super_admin'] ['super_admin', 'admin']
                next()
            }).catch(() => {
                setToken('')
                next()
                // window.location.href = "https://inte.sumibuy.com/sso?redirect=" + to.name + "&auth_redirect=https://v4.sumibuy.com/callback"

                // window.location.href = "http://192.168.40.44:10018/sso?redirect=" + to.name + "&auth_redirect=http://192.168.10.32:9999/callback"
            })
        } else {
            next();
        }
    }
});

router.afterEach((to) => {
    title(to.meta.title + "- 智维（zhiops.com), 一站式研发&运维管理平台");
    ViewUI.LoadingBar.finish();
    window.scrollTo(0, 0);
});

export default router;
